import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { useLocation, useNavigate } from "react-router-dom";
import InstallMobile from "@mui/icons-material/InstallMobile";
import { SideMenuOption } from "../core/SideMenuOption";
import { Path } from "../Path";
import googlePlay from "../assets/google-play.png";
import appStore from "../assets/app-store.svg";

const APP_STORE_LINK = "https://apps.apple.com/au/app/pitch2table/id6560116374";
const PLAY_STORE_LINK = "https://play.google.com/store/apps/details?id=com.pitch2table.app";

export const GoMobileButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const onClickHandler = () => {
    navigate(Path.mobile);
  };

  return (
    <SideMenuOption
      tooltip="How to get the iOS or Android app"
      onClick={onClickHandler}
      selected={location.pathname.startsWith(Path.mobile)}
      label="Mobile"
    >
      <InstallMobile />
    </SideMenuOption>
  );
};

export const GetMobilePage = () => {
  return (
    <Box p={2} width="100%" flex={1}>
      <Card>
        <Box p={2}>
          <Box pb={2}>
            <Typography textAlign="center" variant="h4">
              Get Pitch2Table on Mobile
            </Typography>
          </Box>
          <Box pt={2}>
            <Typography>
              Pitch2Table is on iOS and Android. You can get it from the App Store or Google Play. The mobile app has
              all the same features in a portable format. Always be ready for the pitch!
            </Typography>
          </Box>
          <Box pt={2} display="flex" flexDirection="row" gap={1} alignItems="center">
            <a href={APP_STORE_LINK} target="_blank" rel="noreferrer">
              <img src={appStore} alt="download from the App Store" style={{ width: "auto", height: 44 }} />
            </a>
            <a href={PLAY_STORE_LINK} target="_blank" rel="noreferrer">
              <img src={googlePlay} alt="download from Google Play" style={{ width: "auto", height: 44 }} />
            </a>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};
